import { render, staticRenderFns } from "./Setname.vue?vue&type=template&id=d1c0fb6a&scoped=true"
import script from "./Setname.vue?vue&type=script&lang=js"
export * from "./Setname.vue?vue&type=script&lang=js"
import style0 from "./Setname.vue?vue&type=style&index=0&id=d1c0fb6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c0fb6a",
  null
  
)

export default component.exports